import { createGlobalStyle } from 'styled-components';
import html from './html';
import print from './print';

export const GlobalStyle = createGlobalStyle`
  ${html};
  ${print};

  body {
    & > div {
      &:first-of-type {
        height: 100%;
        /* TODO: Find a way of fixing this without fucking up position:fixed everywhere
        This is used to calculate the height of the address bar on mobile browsers */
        /* perspective: 100vh; */
      }
    }
  }

  /* Focus style for custom checkboxes */
  .custom-focus-checkbox input:focus + label,
  .custom-focus-checkbox input:focus-visible + label {
    outline: 2px solid dodgerblue;
    outline-offset: 2px;
    border-radius: 4px;
  }
`;
